import { type Dispatch, type SetStateAction } from 'react';

import type { ResponseResult } from 'api-client'
// import type {ColDef,
//   ColGroupDef,
//   ExcelDataType,
// } from 'ag-grid-community'

// AGGridを用いたデータ編集時に、APIのインターフェイスに追加する編集管理項目
export interface RecordEditEx {
    id: string | null
    isEdited: boolean
    errors: Record<string, string[]>
    editedFields: Set<string>,
    isNewRecord: boolean,
  }
  export const initRecordEditEx = (isNewRow=false): RecordEditEx => ({
    id: Math.random().toString(32).substring(2),
    isEdited: false,
    errors: {},
    editedFields: new Set<string>(),
    isNewRecord: isNewRow,
  })
  
  export interface SimpleDataListPropsBase {
    list?: any; // データリスト
    isLoading: boolean; // データ読み込み中（ローディング表示）
    searchParam?: any
    setResultMessage?: Dispatch<SetStateAction<ResponseResult | undefined>>, // 親コンポーネントが保持しているInfoMessageのstateを更新する
    setDownloadColumnDefs?: Dispatch<SetStateAction<any[] | undefined>>, // ダウンロードファイルの項目定義
  }
    
  export interface DataListPropsBase extends SimpleDataListPropsBase{
    onReload?: () => void; // 未使用
    onUploadData?: any[]; // インポートボタンから取り込まれたデータが格納される
    updateTrigger?: boolean // 親コンポーネントで登録ボタンを押下された場合に値が変化->Effectで検知して更新処理を実行
    setHasGridEdited: Dispatch<SetStateAction<boolean>>,  // 親コンポーネントが保持しているグリッドの編集状態のstateを更新する
    setResultMessage: Dispatch<SetStateAction<ResponseResult | undefined>>, // 親コンポーネントが保持しているInfoMessageのstateを更新する(必須)
  }
  

 